export default __webpack_public_path__ + "skins/ui/oxide/fonts/tinymce-mobile.woff";